/* eslint-disable no-case-declarations */
import { config } from "~/config/index";
import qs from "qs";
import { UpperCase } from "./common";

export const enum tgLinkType {
    //分享返佣邀请码
    A = "A",
    //分享代币
    B = "B",
    // 站外页面
    D = "REDIRECT",
    //跳转指定页面
    P = "P",
    // 快捷买入
    Q = "Q",
    //跳转订单详情, GO Lang 服务中使用
    TRADEDETAIL = "TRADEDETAIL",
}

export interface tgLinkParseResult {
    type?: keyof tgLinkType;
    params: any;
    path?: string;
}

const extractGroupId = (value: string) => {
    if (String(value).startsWith("g-")) {
        return value.replace("g-", "");
    }

    return null;
};

export const skdUtils = {
    decodeTelegramUrlParameters: function decodeTelegramUrlParameters(
        encodedParameters,
        isObject = true
    ) {
        const decodedParams = encodedParameters
            .replaceAll("--", "%")
            .replaceAll("__", "=")
            .replaceAll("-", "&")
            .replaceAll("%5F", "_")
            .replaceAll("%2D", "-")
            .replaceAll("%2E", ".");
        if (isObject) return qs.parse(decodedParams);
        return decodedParams;
    },
    stringify: function stringify(obj) {
        const params = new URLSearchParams();

        function buildParams(prefix, value) {
            if (Array.isArray(value)) {
                value.forEach((v, i) => {
                    if (/\[\]$/.test(prefix)) {
                        params.append(prefix, v);
                    } else {
                        buildParams(
                            `${prefix}[${typeof v === "object" ? i : ""}]`,
                            v
                        );
                    }
                });
            } else if (typeof value === "object") {
                for (const key in value) {
                    buildParams(`${prefix}[${key}]`, value[key]);
                }
            } else {
                params.append(prefix, value);
            }
        }

        for (const key in obj) {
            buildParams(key, obj[key]);
        }

        return params.toString();
    },
    encodeTelegramUrlParameters: function encodeTelegramUrlParameters(
        parameters,
        isObject = true
    ) {
        if (isObject) {
            parameters = this.stringify(parameters);
        }
        return parameters
            .replaceAll(".", "%2E")
            .replaceAll("-", "%2D")
            .replaceAll("_", "%5F")
            .replaceAll("&", "-")
            .replaceAll("=", "__")
            .replaceAll("%", "--");
    },
};

const getFixContract = (contract = "0x0") => {
    return contract.length > 3
        ? contract
        : "0x0000000000000000000000000000000000000000";
};

class TgLink {
    constructor() {}

    static _getLink(
        type: tgLinkType,
        {
            invite_user_code,
            invite_source,
            contract,
            chain_id,
            order_id,
            pathname,
            from_amount,
            params,
        }: {
            invite_user_code?: string | number;
            invite_source?: string;
            contract?: string;
            chain_id?: string | number;
            order_id?: string;
            pathname?: string;
            from_amount?: string;
            params: any;
        }
    ) {
        switch (type) {
            //渠道邀请码
            case tgLinkType.A:
                if (!invite_user_code) throw "no invite_user_code";
                return `${config.direct_link}?startapp=${type}_${invite_user_code}${invite_source ? `_${invite_source}` : ""}`;
            case tgLinkType.B:
                return `${config.direct_link}?startapp=${type}_${chain_id}_${contract}${invite_user_code ? `_${invite_user_code}` : ""}`;
            case tgLinkType.D:
                return `${config.direct_link}?startapp=${type}_${skdUtils.encodeTelegramUrlParameters(params || {})}`;
            case tgLinkType.P:
                return `${config.direct_link}?startapp=${[type, pathname, chain_id, contract, invite_user_code].filter(Boolean).join("_")}`;
            case tgLinkType.Q:
                return `${config.direct_link}?startapp=${[type, chain_id, contract, String(from_amount).replace(".", "dot"), invite_user_code].filter(Boolean).join("_")}`;
            case tgLinkType.TRADEDETAIL:
                return `${config.direct_link}?startapp=${type}_${order_id}_${chain_id}_${contract}`;
            default:
                break;
        }
        return null;
    }

    static parseLink(link = "") {
        try {
            const [type, ...params] = link.split("_");
            const upperType = UpperCase(type);

            if (upperType === tgLinkType.A) {
                return {
                    type,
                    params: {
                        invite_code: params[0],
                        invite_source: params[1],
                    },
                    path: "",
                };
            } else if (upperType === tgLinkType.B) {
                const [chain_id, contract, invite_code_or_group_id] = params;
                const groupId = extractGroupId(invite_code_or_group_id);

                const additionalParams = groupId
                    ? {
                          referral_group_id: groupId,
                      }
                    : {
                          invite_code: invite_code_or_group_id,
                      };

                return {
                    type,
                    params: { chain_id, contract, ...additionalParams },
                    path: `/k-detail?chain_id=${chain_id}&contract=${getFixContract(contract)}`,
                };
            } else if (upperType === tgLinkType.D) {
                const D_params =
                    skdUtils.decodeTelegramUrlParameters(params?.join?.("_")) ||
                    {};
                if (D_params.path) {
                    const path = D_params.path;
                    delete D_params.path;
                    return {
                        type: type,
                        path: `${path}?${qs.stringify(D_params)}`,
                        params: D_params,
                    };
                }
                return {
                    type: type,
                    path: "",
                    params: D_params,
                };
            } else if (upperType === tgLinkType.P) {
                const [
                    pathname,
                    tokenChainIdParam,
                    tokenContractParam,
                    invite_code_or_group_id,
                ] = params;
                const hasChainId =
                    tokenChainIdParam && tokenChainIdParam.length > 0;
                const queryString = hasChainId
                    ? qs.stringify({
                          chain_id: tokenChainIdParam,
                          contract: getFixContract(tokenContractParam),
                      })
                    : null;

                const groupId = extractGroupId(invite_code_or_group_id);

                return {
                    type,
                    params: groupId
                        ? {
                              referral_group_id: groupId,
                          }
                        : {
                              invite_code: invite_code_or_group_id,
                          },
                    path: `/${pathname}${queryString ? "?" + queryString : ""}`,
                };
            } else if (upperType === tgLinkType.Q) {
                const groupId = extractGroupId(params[3]);
                return {
                    type,
                    params: groupId
                        ? {
                              referral_group_id: groupId,
                          }
                        : {
                              invite_code: params[3],
                          },
                    path: `/quick-buy?chain_id=${params[0]}&contract=${params[1]}&from_amount=${params[2]}`,
                };
            } else if (upperType === tgLinkType.TRADEDETAIL) {
                return {
                    type,
                    params: {},
                    path: `/trade-detail?order_id=${params[0]}&chain_id=${params[1]}&contract=${params[2]}`,
                };
            } else {
                return null;
            }
        } catch (error) {
            console.error("parseLink error", error);
        }
    }
}

export const tgLink = TgLink;
